export const noteDefaultValue = `<p class="ql-direction-rtl ql-align-right">
<strong class="ql-size-large">نکات اپراتور</strong>
</p>
<p class="ql-direction-rtl ql-align-right"><br /></p>
<p class="ql-direction-rtl ql-align-right"><br /></p>
<p class="ql-direction-rtl ql-align-right"><br /></p>
<p class="ql-direction-rtl ql-align-right">
<strong class="ql-size-large">نکات مصاحبه</strong>
</p>
<p class="ql-direction-rtl ql-align-right"><br /></p>
<p class="ql-direction-rtl ql-align-right"><br /></p>
<p class="ql-direction-rtl ql-align-right"><br /></p>
<p class="ql-direction-rtl ql-align-right">
<strong class="ql-size-large">نکات سوپروایزر</strong>
</p>
<p class="ql-direction-rtl ql-align-right"><br /></p>
<p class="ql-direction-rtl ql-align-right"><br /></p>
<p class="ql-direction-rtl ql-align-right"><br /></p>
<p class="ql-direction-rtl ql-align-right">
<strong class="ql-size-large">ایجاد کارت‌های جدید</strong>
</p>

`;

export const defaultTermsValue = {
  term1: {
    id: "term1",
    flags: [],
    title: "",
  },
  term2: {
    id: "term2",
    flags: [],
    title: "",
  },
  term3: {
    id: "term3",
    flags: [],
    title: "",
  },
  term4: {
    id: "term4",
    flags: [],
    title: "",
  },
};
export const defaultSkillsTermsValue = {
  term1: {
    id: "term1",
    skills: [],
    title: "",
  },
  term2: {
    id: "term2",
    skills: [],
    title: "",
  },
  term3: {
    id: "term3",
    skills: [],
    title: "",
  },
  term4: {
    id: "term4",
    skills: [],
    title: "",
  },
};
